import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { UigNewsItem } from './uig-news.model';

@Injectable()
export class UigNewsAdapter {

  constructor (protected http: HttpClient, protected occEndpoints: OccEndpointsService) {}

  // Retrieves array of news items
  getNews(): Observable<UigNewsItem[]> {
    return this.http.get<UigNewsItem[]>(this.occEndpoints.buildUrl('customGetNews'));
  }
}
